<main class="wrapper">
    <app-solutions-title></app-solutions-title>
    <app-industry-section></app-industry-section>
    <app-system-section></app-system-section>
    <app-solutions-section></app-solutions-section>
</main>